if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    var variant = data && data.variant;
    var sectionId = data && data.sectionId;
    if (!variant || !sectionId) return;

    var mapScript = document.getElementById('drop-restock-map-' + sectionId);
    var container = document.querySelector('.drop-restock-buttons[data-section="' + sectionId + '"]');
    if (!mapScript || !container) return;

    var map;
    try {
      map = JSON.parse(mapScript.textContent);
    } catch (e) {
      return;
    }

    var normal = container.querySelector('.drop-restock-buttons__normal');
    var locked = container.querySelector('.drop-restock-buttons__locked');
    if (!normal || !locked) return;

    var isLocked = !!map[variant.id];
    normal.classList.toggle('hidden', isLocked);
    locked.classList.toggle('hidden', !isLocked);
  });
}
